import Sandpack from '@/components/Sandpack'

import App from './Sync.example.tsx?raw'

export default function Example() {
  return (
    <Sandpack
      files={{
        '/App.tsx': App,
      }}
    />
  )
}
